
const convertTableData = (data, numberWithCommas) => {
  const headers = Object.keys(data[0]);
  const content = data.map((row) => {
    const newRow = headers.map(column => {
      const val = row[column];
      if (val == null) return '';
      if (typeof val === 'number') return numberWithCommas(val);
      if (typeof val === 'object') return JSON.stringify(val);
      return val;
    });
    let newJson = {};
    headers.forEach((header, index) => {
      if(!header.endsWith("ID")) {
        newJson[header] = newRow[index];
      }
    })

    return newJson;
  })
  return content;
}
const isFloat = (value) => {
  const number = parseFloat(value);
  return !isNaN(number) && isFinite(value) && value.toString().includes('.');
}
export {
  convertTableData,
  isFloat
}
